

















































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { QueryRenderer } from '@cubejs-client/vue';
import CubeJsChart from './CubeJsChart.vue';
import VueApexCharts from 'vue-apexcharts';
import { DxDataGrid, DxToolbar, DxToolbarItem } from 'devextreme-vue/data-grid';
import { Column, Properties as DataGridProperties } from 'devextreme/ui/data_grid';
import { ResultSet, Query, TimeDimensionGranularity, TableColumn } from '@cubejs-client/core';
import { apiService, cubejsService } from '@/container';
import { clone, cloneDeep, isArray, isEqual, isNil, isObject } from 'lodash';
import { dateFormater } from '@/chartHelper';
import { ApexOptions } from 'apexcharts';
import { IChartConfig, SimilarToArray } from '@/components/charts/resultSetTransform/chartSteps';
import ResultSetViewer from './ResultSetViewer.vue';
import { tryTranslateCaption } from './resultSetTransform';

@Component({
	components: {
		QueryRenderer,
		CubeJsChart,
		VueApexCharts, ResultSetViewer,
		DxDataGrid, DxToolbar, DxToolbarItem
	}
})
export default class ChartRenderNew extends Vue {
	@Prop({ type: String }) idCustomer?: string;
	@Prop({ type: String }) idChart?: string;
	@Prop({ type: String }) chartType?: string;
	@Prop({ type: Array }) queries?: any[];
	@Prop({ type: Array }) config?: IChartConfig[] | IChartConfig | null;
	@Prop({ type: String, default: '100%' }) width!: string | number;
	@Prop({ type: String, default: '350' }) height!: string | number;
	@Prop({ type: Boolean, default: false }) groupingByWeek!: boolean;
	@Prop({ type: Object, default: () => ({}) }) chartProps!: Record<string, unknown>;
	@Prop({ type: Object }) export?: Record<string, () => void>;
	@Prop({ type: Boolean, default: false }) isFromDashboard!: boolean;
	@Prop({ type: Function }) reloadQuery?: (query) => Promise<void>;
	bindReloadQuery() {
		this.$emit('update:reloadQuery', this.internalReloadQuery);
	}

	// queries: any[] = [
	// 	{
	// 		'measures': [
	// 			'Fact_Project.count'
	// 		],
	// 		'dimensions': [
	// 			'Dim_Commission.name'
	// 		],
	// 		'limit': 10000
	// 	},
	// 	{
	// 		'measures': [
	// 			'Fact_Authorization.count'
	// 		],
	// 		'dimensions': [
	// 			'Dim_Commission.name'
	// 		],
	// 		'limit': 10000
	// 	}
	// ];

	loading = true;
	cubejsApi: any = null;
	internalChart: any = {};
	legend: any[] | null = null;
	internalChartData: any | null = null;
	internalIdCustomer: string | null = null;
	internalConfig: any | null = null;
	internalGroupingByWeek = false;
	drillDownDimensions: any = null;
	defaultChartReadonlyOptions: ApexOptions = {
		chart: {
			toolbar: {
				show: true,
				offsetY: 5,
				tools: {
					download: true,
					selection: false,
					zoom: false,
					zoomin: false,
					zoomout: false,
					pan: false,
					reset: false,
					customIcons: []
				},
				export: {
					csv: {
						filename: ((this.internalChart || {}).name) || 'EmptyName'
					},
					svg: {
						filename: ((this.internalChart || {}).name) || 'EmptyName'
					},
					png: {
						filename: ((this.internalChart || {}).name) || 'EmptyName'
					}
				}
			},
			stacked: this.isStacked
		},
		title: {
			text: (this.internalChart || {}).name,
			style: {
				color: 'rgba(0, 143, 251, 0.85)',
				fontSize: '20px',
			}
		},
		xaxis: {
			labels: {
				trim: true
			}
		}
	}

	created() {
		this.bindReloadQuery();
	}

	async mounted() {
		this.$watch(() => this.groupingByWeek, this.onGroupingByWeekChange, { immediate: true });

		this.$watch(() => this.internalChartType, this.onInternalChartTypeChange, { immediate: true });

		this.$watch(() => this.idCustomer, val => {
			if (isNil(val))
				this.internalIdCustomer = null;
			else
				this.internalIdCustomer = val;
		}, { immediate: true });

		this.$watch(() => this.config, async (val) => await this.load(val), { immediate: true });
	}

	async load(config) {
		try {
			this.loading = true;
			if (!isNil(this.idChart)) {
				this.internalChart = await apiService.get('charts', `${this.idChart}`);
				this.internalIdCustomer = this.internalChart.idCustomer;
				this.internalGroupingByWeek = this.internalChart.groupingByWeek;
				if (!isNil(this.internalChart.drillDownConfig) && isArray(JSON.parse(this.internalChart.drillDownConfig))
					&& JSON.parse(this.internalChart.drillDownConfig).length > 0)
					this.drillDownDimensions = JSON.parse(this.internalChart.drillDownConfig);
			} else {
				this.$watch(() => ({ ct: this.chartType, co: config }), val => {
					this.internalChart = {
						type: val.ct,
						name: 'Unknown',
						additionalConfig: val.co
					};
				}, { immediate: true });

			}

			if (!isNil(this.internalIdCustomer))
				this.cubejsApi = await cubejsService.cubejsApi(this.internalIdCustomer);
		} finally {
			this.loading = false;
		}
	}

	get chartQuery() {
		if (!isNil(this.queries))
			return this.queries;

		if (isNil(this.internalChart))
			return null;

		const rawQuery = JSON.parse(this.internalChart.query);
		return isArray(rawQuery) ? rawQuery : [rawQuery];
	}

	get internalChartName() {
		if (isNil(this.idChart))
			return '';

		return this.internalChart.name;
	}

	get internalChartType() {
		if (isNil(this.internalChart))
			return 'line';

		return this.internalChart.type;
	}

	get cubeJsChartConfig() {
		const additionalConfig = this.internalChart.additionalConfig;

		if (!_.isNil(additionalConfig))
			if (isObject(additionalConfig))
				return additionalConfig;
			else
				return JSON.parse(additionalConfig);
		return [];
	}

	get isStacked() {
		return !_.isNil(this.internalConfig) && !_.isNil(this.internalConfig.isStacked) && this.internalConfig.isStacked;
	}

	get readonlyChartProps() {
		if (!_.isNil(this.defaultChartReadonlyOptions)
			&& !_.isNil(this.defaultChartReadonlyOptions.chart)
			&& !_.isNil(this.defaultChartReadonlyOptions.chart.toolbar)
			&& !_.isNil(this.defaultChartReadonlyOptions.chart.toolbar.export)
			&& !_.isNil(this.defaultChartReadonlyOptions.chart.toolbar.export.csv)) {

			if (!_.isNil(this.internalChartName)) {
				this.defaultChartReadonlyOptions.chart.toolbar.export.csv.filename = this.internalChartName;

				if (!_.isNil(this.defaultChartReadonlyOptions.chart.toolbar.export.png))
					this.defaultChartReadonlyOptions.chart.toolbar.export.png.filename = this.internalChartName;

				if (!_.isNil(this.defaultChartReadonlyOptions.chart.toolbar.export.svg))
					this.defaultChartReadonlyOptions.chart.toolbar.export.svg.filename = this.internalChartName;
			}

			if (!_.isNil(this.internalChartName) && !_.isNil(this.defaultChartReadonlyOptions.title))
				this.defaultChartReadonlyOptions.title.text = this.internalChartName;

			if (!_.isNil(this.chartQuery) && _.isArray(this.chartQuery) && this.chartQuery.length > 0 && !_.isNil(this.chartQuery[0].dimensions) && _.isArray(this.chartQuery[0].dimensions)
				&& this.chartQuery[0].dimensions.length > 0)
				this.defaultChartReadonlyOptions.chart.toolbar.export.csv.headerCategory = this.$t(this.chartQuery[0].dimensions[0]);
		}
		return _.merge({}, this.defaultChartReadonlyOptions, this.chartProps);
	}

	getTimeDimensions(): any {
		let query;
		let timeDimensionCode;
		let granularity: TimeDimensionGranularity;

		if (!_.isNil(this.internalChart) && !_.isNil(this.chartQuery) && _.isArray(this.chartQuery) && !_.isNil(this.chartQuery[0]))
			query = this.chartQuery[0];

		if (_.isNil(query) || !_.isArray(query.timeDimensions) || query.timeDimensions.length <= 0 || _.isNil(query.timeDimensions[0].granularity))
			return { timeDimensionCode: null, granularity: null };


		granularity = query.timeDimensions[0].granularity;

		timeDimensionCode = this.normalizeTimeDimentionCode(query.timeDimensions[0].dimension, granularity);
		return { timeDimensionCode: timeDimensionCode, granularity: granularity };
	}

	normalizeTimeDimentionCode(timeDimensionCode, granularity): string {
		return (!_.isNil(timeDimensionCode) && timeDimensionCode.includes('.')
			? timeDimensionCode = timeDimensionCode.replaceAll('.', '_') : timeDimensionCode) + '_' + granularity;
	}

	getTablePropsWithSingleQuery(resultSet: any, editMode: boolean): DataGridProperties {
		const tableColumns = resultSet.tableColumns();
		const containDot = tableColumns.some(c => c.key.includes('.'));

		let dataSource: Array<Record<string, unknown>> = resultSet.tablePivot();

		const timeDimensions = this.getTimeDimensions();

		const columns: Column[] = tableColumns.map(c => ({
			dataField: c.key,
			// this conditional statement was added becouse CubeJs adds the granularity in the trailer
			// of the time dimension so this way everything is normalized and the caption can work
			caption: this.$t(c.type === 'time' ? c.key.replace('.' + timeDimensions.granularity, '') : c.key)
		}));

		if (containDot) {
			const normalizedColumns = tableColumns.reduce((acc, c) => ({
				...acc,
				[c.key]: c.key.includes('.') ? c.key.replaceAll('.', '_') : c.key
			}), {});

			for (const column of columns)
				column.dataField = normalizedColumns[column.dataField!];

			dataSource = dataSource.map(r => Object.entries(r)
				.reduce((acc, [k, v]) => ({ ...acc, [normalizedColumns[k]]: v }), {}));
		}
		this.formatAndTransformDataSource(dataSource);
		return {
			columns,
			dataSource,
			filterRow: { visible: true },
			sorting: { mode: editMode ? 'none' : 'single' },
			paging: { enabled: true, pageSize: 20 },
			export: { enabled: false, fileName: this.internalChartName! },
			toolbar: { visible: !editMode, items: [{ template: 'chartName', location: 'before' }] },
			showColumnLines: true,
			height: this.height
		};
	}

	getTablePropsWithMultipleQuery(resultSets: any, editMode: boolean): DataGridProperties {
		if (isNil(this.chartQuery))
			return {};
		const dimensions = this.chartQuery.reduce((acc, q) => {
			if (isNil(q.dimension))
				return acc;
			acc.concat(...q.dimensions!.filter(d => !acc.includes(d)));
			return acc;
		}, []);

		const tableColumns = resultSets.reduce((accTc, rs) => {

			accTc = accTc.concat(...rs.tableColumns().filter(tc => !accTc.find(ftc => ftc.key === tc.key)));
			return accTc;
		}, [])
			.sort((a,) => dimensions.includes(a.key) ? -1 : 1);
		const containDot = tableColumns.some(c => c.key.includes('.'));

		let commonDimensions: string[] = cloneDeep(this.chartQuery.reduce((acc, q) => {
			if (isNil(q.dimension))
				return acc;

			acc.filter(d => q.dimensions!.includes(d));
			return acc;
		}, this.chartQuery[0].dimensions ?? []));

		if (!isNil(this.chartQuery[0].timeDimensions)) {
			const timeDimensionCode = this.chartQuery[0].timeDimensions[0].dimension + '.' + this.chartQuery[0].timeDimensions[0].granularity;
			commonDimensions.unshift(timeDimensionCode);
		}

		let dataSourcesByResultSet = resultSets
			.map(rs => rs.tablePivot());
		let flattedArrayDataSource = dataSourcesByResultSet.flat();
		let dataSource: any[] = [];
		const flattedArrayDataSourceKeys = flattedArrayDataSource.map(row => ({
			key: commonDimensions.map(commonDim => row[commonDim]),
			value: row
		}));
		flattedArrayDataSource.forEach(element => {
			const elementKeys = commonDimensions.map(dimension => element[dimension]);
			const dataSourceKeys = dataSource.map(record => commonDimensions.map(dimension => record[dimension]));
			const areKeysAlreadyProcessed = dataSourceKeys.some(keys => isEqual(keys.sort(), elementKeys.sort()));

			if (areKeysAlreadyProcessed === false) {
				const linesToPush = flattedArrayDataSourceKeys.filter(keys => isEqual(keys.key.sort(), elementKeys.sort())).map(keys => keys.value);

				let groupedLinesToPush = linesToPush.shift();

				linesToPush.forEach(line => {
					groupedLinesToPush = Object.assign(groupedLinesToPush, line);
				});

				dataSource.push(groupedLinesToPush);
			}
		});

		const timeDimensions = this.getTimeDimensions();
		const columns: Column[] = tableColumns.map(c => ({
			dataField: c.key,
			// this conditional statement was added becouse CubeJs adds the granularity in the trailer
			// of the time dimension so this way everything is normalized and the caption can work
			caption: this.$t(c.type === 'time' ? c.key.replace('.' + timeDimensions.granularity, '') : c.key)
		}));
		if (containDot) {
			const normalizedColumns = tableColumns.reduce((acc, c) => ({
				...acc,
				[c.key]: c.key.includes('.') ? c.key.replaceAll('.', '_') : c.key
			}), {});
			for (const column of columns)
				column.dataField = normalizedColumns[column.dataField!];
			dataSource = dataSource.map(r => Object.entries(r)
				.reduce((acc, [k, v]) => ({ ...acc, [normalizedColumns[k]]: v }), {}));
		}

		this.formatAndTransformDataSource(dataSource);
		return {
			columns,
			dataSource,
			filterRow: { visible: true },
			sorting: { mode: editMode ? 'none' : 'single' },
			paging: { enabled: true, pageSize: 20 },
			export: {
				enabled: false, fileName: this.internalChartName!
			},
			toolbar: { visible: !editMode, items: [{ template: 'chartName', location: 'before' }] },
			showColumnLines: true,
			height: this.height
		};
	}

	getTableProps(resultSet: any, editMode: boolean): DataGridProperties {
		let result: any = null;
		if (Object.keys(resultSet).length > 1)
			result = this.getTablePropsWithMultipleQuery(Array.from({
				...resultSet,
				length: Object.keys(resultSet).length
			}), editMode);
		else
			result = this.getTablePropsWithSingleQuery(!isNil(resultSet[0]) ? resultSet[0] : resultSet, editMode);

		return result;
	}

	extractLegend(val) {
		let legend: any[] = [];
		switch (this.chartType) {
			case 'pie':
			case 'bar':
			case 'line':
			case 'area':
			case 'radar':
				if (isNil(this.legend) || !isArray(this.legend) || this.legend.length === 0)
					return [];
				legend = this.legend.map(x => ({
					value: x.nameCode || x.name,
					fillColor: x.color,
					localeValue: x.name,
					queryIndex: x.queryIndex
				}));
				break;
			default:
				legend = [];
				break;
		}
		return legend;
	}

	extractColors(val) {
		let colors = [];
		switch (this.chartType) {
			case 'pie':
			case 'bar':
			case 'line':
			case 'area':
			case 'radar':
				if (!_.isNil(val) && !_.isNil(val.options) && !_.isNil(val.options.colors)
					&& _.isArray(val.options.colors) && val.options.colors.length > 0)
					colors = val.options.colors;
				break;
			default:
				colors = [];
				break;
		}
		return colors;
	}

	getDefaultColorIndex(i) {
		const multiplier = Math.floor(i / 5);
		const subtraction = multiplier * 5;
		return i - subtraction;
	}

	defaultColor: string[] = ['#008FFB', '#00E396', '#FEB019', '#FF4560', '#775DD0'];

	onLegendUpdated(val) {
		this.legend = val;
		let colorConfig: any = {};
		let legendWithColors = this.extractLegend(this.internalChartData);
		// if (this.chartType === 'pie') {
		// 	let colors = this.extractColors(this.internalChartData);
		// 	colorConfig.colors = legendWithColors.map((x, index) => ({
		// 		value: x,
		// 		fillColor: colors[index] ?? this.defaultColor[this.getDefaultColorIndex(index)]
		// 	}));
		// } else
		colorConfig.colors = this.chartType !== 'pie' ? legendWithColors : legendWithColors.map((x, index) => ({
			value: x.value,
			fillColor: legendWithColors[index].fillColor ?? this.defaultColor[this.getDefaultColorIndex(index)],
			queryIndex: !isNil(this.legend) && isArray(this.legend) ? this.legend[index].queryIndex : 0
		}));

		let internalChartConfig: IChartConfig[] | IChartConfig | null | undefined = cloneDeep(this.config);

		if (_.isArray(internalChartConfig))
			internalChartConfig?.forEach((c, i) => {
				c.colors = colorConfig.colors.filter(color => color.queryIndex == i);
			});
		else if (!isNil(internalChartConfig))
			internalChartConfig.colors = colorConfig.colors;

		this.$emit('update:config', internalChartConfig);
	}

	onGlobalFilterUpdated(val) {


		this.$emit('update:globalFilter', val);

		if (this.isFromDashboard) {
			const operator = 'equals';
			let additionalConfig = JSON.parse(this.internalChart.additionalConfig);
			const globalQuery = JSON.parse(this.internalChart.globalQuery);
			const dimensionForFilter = additionalConfig[0].axisDimensions.map(x => x.name);
			let nextDimensions: any = null;
			if (isNil(this.drillDownDimensions) || !isArray(this.drillDownDimensions) || (this.drillDownDimensions as any).length <= 0)
				return;

			const index = this.drillDownDimensions.findIndex(dimension => {
				return dimensionForFilter.every(item => dimension.includes(item));
			});
			if (index == -1)
				nextDimensions = this.drillDownDimensions[0];
			else
				nextDimensions = this.drillDownDimensions[index + 1];

			if (isNil(nextDimensions))
				return;

			this.$emit('isInDrillDownMode', true);
			this.$emit('drillDownPreviousQuery', cloneDeep(this.internalChart));

			const filterToAdd = dimensionForFilter.map((dimension) => {
				const filterSet = {
					member: dimension,
					operator: operator,
					values: [val[dimension]],
				};
				return filterSet;
			});
			globalQuery.query.dimensions = nextDimensions;
			globalQuery.pivotConfig.x = nextDimensions;
			globalQuery.globalFilter = this.addFilter(globalQuery.globalFilter, filterToAdd);
			this.internalChart.globalQuery = JSON.stringify(globalQuery);

			additionalConfig.forEach(ac => {
				const legendDimensionsName = ac.legendDimensions.map(x => x.name);
				ac.axisDimensions = nextDimensions.filter(x => !legendDimensionsName.includes(x)).map(dim => ({ name: dim }));
				ac.selectedDimensions = nextDimensions.map(dim => ({ name: dim }));
			});
			this.internalChart.additionalConfig = JSON.stringify(additionalConfig);

			const query = JSON.parse(this.internalChart.query);
			query.forEach(q => {
				q.dimensions = nextDimensions;
				q.filters = this.addFilter(q, filterToAdd);
			});
			this.internalChart.query = JSON.stringify(query);

			(this.$refs.cubeJSChartRef as any).updateReloadKey(this.cubeJsChartConfig);
		}
	}

	internalReloadQuery(query: string) {
		this.internalChart = query;
		(this.$refs.cubeJSChartRef as any).updateReloadKey(this.cubeJsChartConfig);
	}

	addFilter(filter, filterToAdd) {
		if (!filter || !filter[0] || Object.keys(filter[0]).length === 0) {
			filter = [{ and: [...filterToAdd] }];
		} else if (filter.length === 1 && !filter[0].and) {
			const andArray = [filter[0], { and: [...filterToAdd] }];
			filter = [{ and: andArray }];
		} else if (!filter[0].and) {
			filter[0].and = [...filterToAdd];
		} else {
			filter[0].and.push(...filterToAdd);
		}
		return filter;
	}

	formatAndTransformDataSource(dataSource) {
		const timeDimensions = this.getTimeDimensions();
		dataSource.forEach((row) => {
			if (!_.isNil(timeDimensions.timeDimensionCode) && !_.isNil(timeDimensions.granularity) && !_.isNil(row[timeDimensions.timeDimensionCode]) && _.isString(row[timeDimensions.timeDimensionCode]))
				row[timeDimensions.timeDimensionCode] = dateFormater(new Date(row[timeDimensions.timeDimensionCode] as Date), this.internalGroupingByWeek ? 'week' : timeDimensions.granularity as TimeDimensionGranularity);

			Object.keys(row).forEach((column) => {
				if (/\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d(?:\.\d+)?Z?/gm.test(row[column] as any) && column != timeDimensions.timeDimensionCode)
					row[column] = dateFormater(new Date(row[column] as string), 'second' as TimeDimensionGranularity);

				row[column] = tryTranslateCaption((row[column] as string), this.$t);
			});
		});
	}

	getWeekResult(data: any) {
		data.forEach(d => {
			d.x = dateFormater(new Date(d.x), 'week');
		});
		return this.groupByWeek(data);
	}

	//grouping data with 'day' granularity by week
	groupByWeek(data: any): any {
		const result = Array.from(data.reduce(
			(m, { x, y }) => m.set(x, (m.get(x) || 0) + y), new Map
		), ([x, y]) => ({ x, y }));
		return result;
	}

	async onInternalChartTypeChange(): Promise<void> {
		if (this.internalChartType === 'table')
			this.$emit('update:export', {
				excel: () => {
					(this.$refs.dataGrid as any).$_instance.exportToExcel();
				}
			});
	}

	onGroupingByWeekChange(val) {
		this.internalGroupingByWeek = val;
	}
}
